/**
 * Main JavaScript file.
 */
import LazyLoad from 'vanilla-lazyload';
import './mobile-menu';
import './facet-wp-custom';
import Alpine from 'alpinejs';
import Swiper, { Pagination, Autoplay, Lazy, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import lightbox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.min.css';
import TypeWriter from 'typewriter-effect/dist/core';

document.addEventListener('facetwp-loaded', function() {
	jQuery('.facetwp-toggle').get(1).click();
 });

document.addEventListener('DOMContentLoaded', () => {

	const search = jQuery('input[name="s"]');
	jQuery(search).attr('placeholder', "Ich suche nach ... ");

	const customNodeCreator = function (character) {
		const placeholder = jQuery(search).attr('placeholder');
		jQuery(search).attr('placeholder', placeholder + character);

		return null;
	};

	const onRemoveNode = function ({ character }) {
		const placeholder = jQuery(search).attr('placeholder');
		if (placeholder) {
			jQuery(search).attr('placeholder', placeholder.slice(0, -1));
		}
		return null;
	};

	const typewriter = new TypeWriter(null, {
		strings: ['Räder', 'Ski', 'Helme'],
		loop: true,
		autoStart: true,
		delay: 75,
		onCreateTextNode: customNodeCreator,
		onRemoveNode,
	});
});

document.addEventListener('DOMContentLoaded', () => {
	new LazyLoad();
	window.Alpine = Alpine;
	Alpine.start();

	const swiper = new Swiper('.home-slider .swiper', {
		modules: [Pagination, Autoplay, Lazy],
		direction: 'horizontal',
		loop: true,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
			disableOnInteraction: false,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
		},
	});

	const logoSwiper = new Swiper('.brandslider .swiper', {
		modules: [Pagination, Autoplay],
		direction: 'horizontal',
		loop: true,
		slidesPerView: 'auto',
		autoplay: {
			delay: 700,
			pauseOnMouseEnter: true,
			disableOnInteraction: false,
		},
	});

	const productSlider = new Swiper('.productslider .swiper', {
		modules: [Lazy, Navigation],
		direction: 'horizontal',
		loop: true,
		slidesPerView: 'auto',
		navigation: {
			nextEl: '.productslider .swiper-button-next',
			prevEl: '.productslider .swiper-button-prev',
		},
	});

	/** FacetWP */
	(function ($) {
		document.addEventListener('facetwp-loaded', function () {
			const $span = $('.facetwp-facet-american_sale .facetwp-checkbox span');
			$('.facetwp-facet-american_sale .facetwp-checkbox').html('American Sale ');
			$('.facetwp-facet-american_sale .facetwp-checkbox').append($span);
		});
	})(jQuery);
});
